/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostUsersAuthRefreshMutationResponse, PostUsersAuthRefresh400 } from '../entities/PostUsersAuthRefresh'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postUsersAuthRefresh } from '../api/postUsersAuthRefresh'
import { useMutation } from '@tanstack/react-query'

export const postUsersAuthRefreshMutationKey = () => [{ url: '/users/auth/refresh' }] as const

export type PostUsersAuthRefreshMutationKey = ReturnType<typeof postUsersAuthRefreshMutationKey>

/**
 * @description Обновление токена
 * @summary Обновление токена
 * {@link /users/auth/refresh}
 */
export function usePostUsersAuthRefresh<TContext>(
  options: {
    mutation?: UseMutationOptions<PostUsersAuthRefreshMutationResponse, ResponseErrorConfig<PostUsersAuthRefresh400>, void, TContext> & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postUsersAuthRefreshMutationKey()

  return useMutation<PostUsersAuthRefreshMutationResponse, ResponseErrorConfig<PostUsersAuthRefresh400>, void, TContext>(
    {
      mutationFn: async () => {
        return postUsersAuthRefresh(config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}